import { Navigate } from 'react-router-dom';

import { ROUTES } from '#/routes';
import { ACCESS_TOKEN, getLocalStorageItem, getSessionStorageItem } from '#/utils';

export function PrivateRoute({ children }) {
    if (!getLocalStorageItem(ACCESS_TOKEN) && !getSessionStorageItem(ACCESS_TOKEN))
        return <Navigate to={ROUTES.LOGIN} replace />;
    return children;
}
